import { getIconName } from "@Pages/PropertyPage/components/RoomTypeSection/utils";
import styles from "./FeatureTags.module.scss";
import LazyLoadOnScroll from "@Components/LazyLoadOnScroll";
import wrapperHOC from "@Utils/wrapperHOC";

interface Props {
  data: any;
  dataTestId?: string;
}
const FeatureTags = (props: Props) => {
  const { data, dataTestId } = props;
  const tags = data || [];

  return (
    <div className={styles.container}>
      {tags?.map((it: string) => (
        <div key={it} className={styles.tagWrapper} data-testid={dataTestId}>
          <LazyLoadOnScroll
            customRootMargin="0px"
            fallback={
              <section
                style={{
                  height: "12px",
                  width: "12px",
                }}
              />
            }
          >
            {getIconName(it)}
          </LazyLoadOnScroll>
          {it}
        </div>
      ))}
    </div>
  );
};

export default wrapperHOC(FeatureTags, {
  componentName: "FeatureTags-SearchListItemDesktop-SearchPage",
  showForChina: true,
});
